import React from 'react'
import PrismicReact from 'prismic-reactjs'
import PrismicConfig from '../config/prismic'

// -- Function to add unique key to props
const propsWithUniqueKey = function(props, key) {
  return Object.assign(props || {}, { key });
};
// -- HTML Serializer
// This function will be used to change the way the HTML is loaded
const Elements = PrismicReact.RichText.Elements

const htmlSerializer = function(type, element, content, children, key) {
 
  var props = {};
  switch(type) {
    
    // Add a class to hyperlinks
    case Elements.hyperlink:
      const targetAttr = element.data.target ? { target: element.data.target } : {};
      const relAttr = element.data.target ? { rel: 'noopener' } : {};
      props = Object.assign({
        className: 'link-class',
        href: element.data.url || PrismicConfig.linkResolver(element.data)
        // href: element.data.url || `#${PrismicConfig.linkResolver(element.data)}`
      }, targetAttr, relAttr);
      return React.createElement('a', propsWithUniqueKey(props, key), children);
 
    // Return null to stick with the default behavior
    default: 
      return null;
  }
}

export default htmlSerializer


// WEBPACK FOOTER //
// ./src/plugins/htmlSerializer.js